module.exports = __webpack_public_path__ + "static/media/cover.c9b4d5a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cover.jpg
// module id = 551
// module chunks = 0